import { useState } from "react";
import { useNavigate } from "react-router-dom";
import RenderTable from "./renderTable";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { handleDelete } from "../services";
import { getAssessmentIdAPIresponse } from "../../../services";
import { GenericModal } from "@asez/component-library";
import { SpinnerButton } from "@asez/component-library";
import { INPUT_VARIANTS, SIZES } from "@asez/shared";
import { GenericInput } from "@asez/component-library";
import { STATIC_STRINGS } from "@asez/shared";

const RenderGrid = ({ data, setFetchOptions }: any) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [open, setOpen] = useState("");
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleCreateAssessment = async () => {
    setLoading(true);
    const assessmentId = await getAssessmentIdAPIresponse();
    navigate(`/edit/${assessmentId}`);
  };

  const updateSelectedAssessment = (assessmentId) => {
    setOpen(assessmentId);
  };
  return (
    <div className="card h-full">
      {/* Header  */}
      <div className="flex justify-between items-center mb-4">
        <GenericInput
          label={STATIC_STRINGS.ASSESSMENT_SEARCH_PLACEHOLDER}
          type="text"
          variant={INPUT_VARIANTS.outlined}
          size={SIZES.sm}
          className="w-1/3"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <SpinnerButton
          className="w-56"
          onClickHandler={handleCreateAssessment}
          loading={loading}
          size={SIZES.sm}
        >
          {STATIC_STRINGS.CREATE_NEW_ASSESSMENT_TITLE}
        </SpinnerButton>
      </div>

      {/* Table Grid */}
      <RenderTable
        searchTerm={searchTerm}
        data={data}
        setFetchOptions={setFetchOptions}
        updateAssessmentId={updateSelectedAssessment}
      />

      {/* Delete Modal */}
      <GenericModal
        open={open}
        onClose={() => setOpen("")}
        loading={deleteLoading}
        onConfirm={async () => {
          setDeleteLoading(true);
          try {
            await handleDelete(open);
            setFetchOptions({
              requestId: new Date().getTime().toString(),
            });
          } catch (error) {
            console.log("DELETE API FAILED");
          }
          setOpen("");
          setDeleteLoading(false);
        }}
        title={STATIC_STRINGS.ASSESSMENT_DELETE_HEADING}
        body={STATIC_STRINGS.ASSESSMENT_DELETE_DESC}
        confirmText={STATIC_STRINGS.DELETE}
        cancelText={STATIC_STRINGS.CANCEL}
        confirmColor="error"
        Icon={DeleteOutlineIcon}
      />
    </div>
  );
};

export default RenderGrid;
